import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { Button, CustomContainer, FlexRow, Form, FormGroup, ScreenTitle } from "src/style"
import { TxPinVerification } from "src/component"
import utility from "src/utils/utility"

export const NewOverdraft: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({amount: ''})
    const [view, setView] = useState('new-overdraft')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        let val = e.target.value.replace(/,/g, '')
        if (!isNaN(Number(val))) {
            setInput({...input, [e.target.name]: val})
        }
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
        notifier.show('Request Submitted', null, 'success')
        close()
    }

    return (
        <>
            { view === 'new-overdraft' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">New Overdraft</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroup>
                                <label>Overdraft Amount</label>
                                <input 
                                    placeholder='Enter Overdraft Amount' 
                                    name='amount'
                                    value={input.amount ? utility.moneyFormat(input.amount) : ''}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FlexRow justifyContent='flex-end' gap="1.5" topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    next={handleSubmit} 
                />
            }
        </>
    )
}